export const enum BuildingReviewLandingAutocompleteStatechartStateEnum {
  /**
   * Autocomplete idle state
   */
  idle = 'idle',

  /**
   * Fetching for list items
   */
  fetchingListItems = 'fetchingListItems',

  /**
   * We're checking if autocomplete has list items to show
   */
  checkingIfHasListItems = 'checkingIfHasListItems',

  /**
   * Selected list item from dropdown
   */
  listItemSelected = 'listItemSelected',
}
